<template>
  <div class="footer-bar" :class="cssHidden">
    <div class="footer-middle">
      美容美发属于本公司 (
      <span style="cursor: pointer;" @click="openNewPage">www.duofriend.com</span>) 旗下子品牌，未经本公司许可授权，任何人不得擅自使用。
    </div>
    <div class="footer-bottom">技术支持：<img class="footer-logo" src="static/images/logo.png">服务热线：400 889 4522</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cssHidden: 'hidden'
    };
  },
  methods: {
    openNewPage() {
      window.open('https://www.duofriend.com/');
    }
  }
};
</script>

<style>
.footer-bar {
    font-size: 11px;
    color: #999;
    text-align: center;
    background-color: #f5f5f5;
    padding: 18px 0;
}
.footer-bar .footer-middle {
    margin-bottom: 10px;
}
.footer-bar .footer-logo {
    margin: 0 20px 0 10px;
}
.footer-bar img {
    vertical-align: top;
}
.hidden {
    display: none;
}
</style>
